module.exports = __webpack_public_path__ + "img/lv3_1_1.02b1b063.png";